import { isFalsy } from "@/lib/helpers";

export interface DefaultFilter {
  name: string;
  default_value?: any;
}

export const getDefaultsToSet = (
  filters: DefaultFilter[] = [],
  params: Record<string, any> = {}
) => {
  // URL-global drill-through sentinel — see Reports/DatatableFilter.vue's
  // setInitialFilters for the contract. When a caller (e.g., the Membership
  // Health Dashboard) wants to bypass the report's filter defaults, it
  // appends `from_dashboard=1` to the click-through URL.
  if (params.from_dashboard === "1") return {};

  const hasExistingFilterParam = filters.some(
    (f) => !isFalsy(params[f.name])
  );

  if (hasExistingFilterParam) return {};

  return filters.reduce((acc, filter) => {
    if (!isFalsy(filter.default_value) && isFalsy(params[filter.name])) {
      acc[filter.name] = filter.default_value ?? null;
    }
    return acc;
  }, {} as Record<string, any>);
};
